import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@app/store/auth.store';
import { getDefaultAdminRoute } from '@features/auth/roles';

/**
 * Requires an authenticated session. Unauthenticated users are sent to /login
 * with a `from` param so they return to where they were after signing in.
 * Users who must enroll MFA are forced to /admin/security.
 */
export function AuthGuard() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const mustEnrollMfa = useAuthStore(
    (s) => s.user?.flags.mustEnrollMfa === true,
  );
  const location = useLocation();

  if (!isAuthenticated) {
    const from = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?from=${from}`} replace />;
  }

  const onSecurity = location.pathname.startsWith('/admin/security');
  if (mustEnrollMfa && !onSecurity) {
    return <Navigate to="/admin/security" replace />;
  }

  return <Outlet />;
}

/** For unauthenticated-only routes (login). Authed users go to the app. */
export function GuestGuard() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  const mustEnrollMfa = useAuthStore(
    (s) => s.user?.flags.mustEnrollMfa === true,
  );
  if (isAuthenticated) {
    return (
      <Navigate
        to={mustEnrollMfa ? '/admin/security' : getDefaultAdminRoute(user)}
        replace
      />
    );
  }
  return <Outlet />;
}
